export const BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1400,
    '3xl': 1910,
} as const;

/**
 * Breakpoint values in pixel units for CSS
 */
export const BREAKPOINTS_PX = Object.fromEntries(
    Object.entries(BREAKPOINTS).map(([k, v]) => [k, `${v}px`])
) as Record<keyof typeof BREAKPOINTS, string>;

export type BreakpointKey = keyof typeof BREAKPOINTS;
